'use strict';

angular.module('chatEngine.verify', [
    'chatEngine.services',
    'chatEngine.dialog',
    'chatEngine.mixpanel'
])

.controller('VerifyCtrl', ['$scope', '$window', '$http', '$location', '$timeout', '$modal', 'Dialog', 'socketService',
    'authService', 'mixpanelService', 'kikService', 'DEBUG', 'BOTSWORTH_USERNAME', 'storageService', 'alertService',
    '$routeParams', function($scope, $window, $http, $location, $timeout, $modal, Dialog, socketService, authService,
    mixpanelService, kikService, DEBUG, BOTSWORTH_USERNAME, storageService, alertService, $routeParams) {

    mixpanelService.forceTrack('Verify Show');

    $scope.message = 'default';

    function init() {
        authService.clearAuthCookies();
        $scope.showScan = true;
        $scope.showScanLoader = true;
        if (kikService.utils && ['ios', 'android'].indexOf(kikService.utils.platform.os.name) !== -1) {
            if (kikService.enabled) {
                // Inside kik
                kikLogin();
            } else {
                // Not in kik, try to open in Kik
                $timeout(function() {
                    window.location.protocol = 'cards';
                }, 1000);
                scanLogin();
            }
        } else {
            scanLogin();
        }
    }

    function kikLogin() {
        $timeout(function() {
            $scope.message = 'kikLogin';
            $scope.showScan = false;
            $scope.showScanLoader = false;
        }, 200);
    }

    $scope.kikAuth = function() {
        var DATA_TO_SIGN = {data: 'login'};
        kikService.sign(JSON.stringify(DATA_TO_SIGN), function(signedData, username, host) {
            if (!signedData) {
                $scope.$apply(function() {
                    $scope.showScan = false;
                    $scope.showScanLoader = false;
                    $scope.message = 'kikLoginTerminated';
                });
            } else {
                $scope.showScan = true;
                $scope.showScanLoader = true;
                $http.post(
                    '/api/v1/kik-email-verification-session',
                    {
                        'signedData': signedData,
                        'username': username,
                        'host': host,
                        'verificationKey': $routeParams.id
                    }
                ).success(function() {
                    $scope.message = 'success';
                    $scope.showScan = false;
                    $scope.showScanLoader = false;
                    $timeout(function() {
                        $scope.openConvo();
                    }, 400);
                    mixpanelService.forceTrack('Kik Verify Success');
                })
                .error(function(data, status) {
                    var openBotsworth = true;
                    if (status === 400 && data.error === 'BadRequest') {
                        $scope.message = 'alreadyVerified';
                        mixpanelService.forceTrack('Kik Already Verified Error');
                    } else if (status === 403 && data.error === 'Forbidden') {
                        $scope.message = 'invalidVerificationKey';
                        mixpanelService.forceTrack('Kik Invalid Verification Key Error');
                        openBotsworth = false;
                    } else if (status === 403 && data.error === 'Conflict') {
                        $scope.message = 'emailTaken';
                        mixpanelService.forceTrack('Kik Email Taken Error');
                        openBotsworth = false;
                    } else if (status === 400 && data.error === 'Expired') {
                        $scope.message = 'expiredVerificationKey';
                        mixpanelService.forceTrack('Kik Expired Email Verification Error');
                        openBotsworth = false;
                    } else if (status === 409) {
                        $scope.message = 'success';
                        mixpanelService.forceTrack('Kik Verify Success in Creation State');
                    } else if (status === 500 && data.error === 'BotsworthMessageError') {
                        $scope.message = 'errorVerified';
                        openBotsworth = false;
                        mixpanelService.forceTrack('Kik Verify Botsworth Message Error');
                    } else {
                        $scope.message = 'error';
                        openBotsworth = false;
                        mixpanelService.forceTrack('Kik Verify Error');
                    }
                    $scope.showScan = false;
                    $scope.showScanLoader = false;
                    if (openBotsworth) {
                        $timeout(function() {
                            $scope.openConvo();
                        }, 400);
                    }
                });
            }
        }, true);
    };

    function scanLogin() {
        $http.get('/api/v1/login?verification_key=' + $routeParams.id)
        .success(function(data) {
            $scope.codeError = false;
            $scope.showScan = true;
            $scope.showScanLoader = false;
            $scope.kikCode = data.code;
            socketService.init(data.socketId, data.socketToken);
        })
        .error(function(data) {
            $scope.showScan = false;
            $scope.showScanLoader = false;
            if (data.error === 'NotFound') {
                $scope.message = 'invalidVerificationKey';
                mixpanelService.forceTrack('Invalid Verification Key Error');
            } else if (data.error === 'Expired') {
                $scope.message = 'expiredVerificationKey';
                mixpanelService.forceTrack('Expired Email Verification Error');
            } else if (data.error === 'BadRequest') {
                $scope.message = 'alreadyVerified';
                mixpanelService.forceTrack('Already Verified Error');
            } else {
                $scope.message = 'errorKikCode';
                mixpanelService.forceTrack('Verify Kik Code Error');
            }
        });
    }

    function animateLogin(data, callback) {
        $scope.message = 'success';
        $timeout(function() {
            if (data.new_bot) {
                storageService.setItem('last-route', '/engine');
            }
            if (!data.tos) {
                $location.path('/tos');
            } else {
                var path = storageService.getItem('last-route');
                if(!path || path.indexOf('/verify') === 0) {
                    path = '/reporting';
                }
                $location.path(path);
                storageService.removeItem('last-route');
            }
            callback();
        }, 700);
    }

    init();

    $scope.openConvo = function() {
        kikService.openConversation(BOTSWORTH_USERNAME);
    };

    $scope.$watch('showScan', function(current) {
        if (!current) {
            var ignoreMessageList = [
                'loginTerminated',
                'kikLoginTerminated',
                'error',
                'errorKikCode',
                'kikLogin',
                'invalidVerificationKey',
                'expiredVerificationKey',
                'alreadyVerified',
                'errorVerified',
                'success',
                'emailTaken'
            ];

            if(ignoreMessageList.indexOf($scope.message) === -1) {
                $scope.message = 'default';
            }
        }
    });

    $scope.$on('LoginSuccess', function(event, data) {
        if (data && data.cookie) {
            $scope.$apply(function() {
                socketService.closeSocket();

                animateLogin(data, function() {
                    authService.setEngineCookie(data.cookie);

                    $http.get('/api/v1/contact')
                        .error(function() {
                            Dialog.alert('Error', 'An error occurred while loading your information.');
                        })
                        .success(function(response) {
                            alertService.setShowAppleIdAlert(!response.apple_developer_id);
                        });
                });
            });

            mixpanelService.forceTrack('Verify Email Success');
        } else {
            $scope.$apply(function() {
                $scope.message = 'errorToken';
                $timeout(init, 800);
            });

            mixpanelService.forceTrack('Verify Email Token Error');
        }
    });

    $scope.$on('NoBots', function() {
        $scope.$apply(function() {
            $scope.message = 'noBots';
            $timeout(init, 800);
        });

        mixpanelService.forceTrack('Verify Email No Bots');
    });

    $scope.$on('ExpiredKey', function() {
        $scope.$apply(function() {
            $scope.message = 'expiredKey';
            $timeout(init, 800);
        });

        mixpanelService.forceTrack('Verify Email Expired Code Key');
    });

    $scope.$on('ExpiredVerificationKey', function() {
        $scope.$apply(function() {
            $scope.showScan = false;
            $timeout(function() {
                $scope.message = 'expiredVerificationKey';
            }, 200);
        });
        mixpanelService.forceTrack('Verify Email Expired Verification Key');
    });

    $scope.$on('EmailTaken', function() {
        $scope.$apply(function() {
            $scope.showScan = false;
            $timeout(function() {
                $scope.message = 'emailTaken';
            }, 200);
        });
        mixpanelService.forceTrack('Verify Email Taken');
    });

    $scope.$on('InvalidVerificationKey', function() {
        $scope.$apply(function() {
            $scope.showScan = false;
            $timeout(function() {
                $scope.message = 'invalidVerificationKey';
            }, 200);
        });
        mixpanelService.forceTrack('Verify Email Invalid Key');
    });

    $scope.$on('WaitingForConfirmation', function() {
        $scope.$apply(function() {
            $scope.showScan = false;
            $timeout(function() {
                $scope.message = 'waitingConfirmation';
            }, 200);
        });

        mixpanelService.forceTrack('Verify Email Waiting Confirmation');
    });

    $scope.$on('LoginTerminated', function() {
        $scope.$apply(function() {
            $scope.message = 'loginTerminated';
            $timeout(init, 200);
        });

        mixpanelService.forceTrack('Verify Email Terminated');
    });

    $scope.$on('socketError', function() {
        $scope.$apply(function() {
            $timeout(init, 800);
        });

        mixpanelService.forceTrack('Verify Email Socket Error');
    });

    $scope.$on('$destroy', function() {
        socketService.closeSocket();
    });

    var authUser = $location.search().authuser;

    if (parseInt(authUser) === 1) {
        $timeout(function() {
            Dialog.alert('Access Denied', 'Please log in with an authorized account and then try again');
            authService.clearAuthCookies();
        }, 300);
    }

    $scope.scanCodeTutorial = function() {
        $modal.open({
            templateUrl: 'views/scan-code-tutorial-dialog.html',
            windowClass: 'scan-code-tutorial-dialog'
        });
    };
}]);
